<template>
  <!-- Top Bar Start -->
  <div class="topbar ">
    <nav class="navbar-custom">
      <ul class="list-unstyled topbar-nav float-right mb-0">
        <li class="dropdown">
          <a
            class="nav-link dropdown-toggle waves-effect waves-light nav-user"
            data-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="false"
            aria-expanded="false"
          >
            <img
              :src="
                profileImg
                  ? $apiDomain + profileImg
                  : '/assets/images/users/user-4.jpg'
              "
              alt="profile-user"
              class="rounded-circle"
            />
            <span class="ml-1 nav-user-name hidden-sm">
              {{ authUserName }} <i class="mdi mdi-chevron-down"></i>
            </span>
          </a>
          <div class="dropdown-menu dropdown-menu-right">
            <router-link :to="{ name: 'MyAccount' }" class="dropdown-item">
              <i class="dripicons-user text-muted mr-2"></i> Profile
            </router-link>

            <div class="dropdown-divider"></div>
            <button class="dropdown-item" @click="logout">
              <i class="dripicons-exit text-muted mr-2"></i> Çıkış
            </button>
          </div>
        </li>
      </ul>
      <!--end topbar-nav-->

      <ul class="list-unstyled topbar-nav mb-0">
        <li>
          <a href="#">
            <span class="responsive-logo">
              <img
                src="/fav.png"
                alt="logo-small"
                class="logo-sm align-self-center"
                height="34"
              />
            </span>
          </a>
        </li>
      </ul>
      <div class="p-3 float-right">
        <button
          type="button"
          class="btn btn-danger waves-effect waves-light"
          @click="endSession"
        >
          Oturumu Sonlandır
        </button>
      </div>
      <div class="ml-5 p-4 float-left">
        <span id="left-time" class="left-time">50:00</span>
      </div>
    </nav>
  </div>

  <!-- Navbar -->

  <!-- end navbar-->

  <!-- Top Bar End -->
</template>

<script>
import router from "@/router";
import EventBus from "@/components/event-bus";

export default {
  name: "topbar",
  data() {
    return {
      authUserName: null,
      profileImg: null
    };
  },
  created() {
    this.setUserName();
  },
  methods: {
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("role");
      // window.location = this.$appDomain;
      router.push({ name: "Login" });
    },
    setUserName() {
      this.authUserName = JSON.parse(localStorage.getItem("user")).name;
      this.profileImg = JSON.parse(localStorage.getItem("user")).profileImg;
    },
    endSession: function() {
      EventBus.$emit("endSession", true);
    }
  },
  mounted() {
    window.init();
    EventBus.$on("updateAuthUserInfo", () => {
      this.setUserName();
    });
  }
};
</script>
